import Script from "next/script";
import React from "react";

// // // //

/**
 * CatalystScript
 * Loads reb2b B2B visitor identification tracking script
 */
export function CatalystScript() {
    return (
        <Script id="catalyst-reb2b" strategy="afterInteractive">
            {`!function(key) {
                if (window.reb2b) return;
                window.reb2b = {loaded: true};
                var s = document.createElement("script");
                s.async = true;
                s.src = "https://ddwl4m2hdecbv.cloudfront.net/b/" + key + "/" + key + ".js.gz";
                document.getElementsByTagName("script")[0].parentNode.insertBefore(s, document.getElementsByTagName("script")[0]);
            }("961Y0H42DXNG");`}
        </Script>
    );
}
